import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import TabsContainer from './../tabsContainer/TabsContainer';
import FlightManager from './../flightManager/FlightManager';
import FaultsManager from './../faultsManager/FaultsManager';
import CommentsManager from './../commentsManager/CommentsManager';
import { translate } from "react-i18next";
import UserWrapper from './../grid/userWrapper/UserWrapper';
import UploadPanel from './../grid/uploadPanel/UploadPanel';

const LeftPanelContentWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;

    .react-tabs__tab--selected{
        background: linear-gradient(0deg, #263650 100%, #265a9c 100%);
        color: #ffffff;
        border: none;
        bottom: 0;
        border-bottom: 3px solid #ffffff;
        padding: 2px;
        pointer-events: none;
    }
    .react-tabs__tab{
        padding: 6px;
        border: 2px solid #265a9c;
    }
    .react-tabs__tab-list{
        border-bottom: none;
        background: linear-gradient(0deg, #263650 100%, #265a9c 100%);
        color: #969eaa;
        padding: 0 0 5px 5px;
        margin: 0;
    }
    .react-tabs__tab-panel--selected {
        display: flex;
        overflow-y: auto;
        margin-top: 10px;
    }
    .settings_tab_list {
        background: transparent;
        color: #969eaa;
        padding: 0;
        margin: 0 0 -5px 0;
        width: fit-content;
        z-index: 5;
        border-bottom: 4px solid white;
        display: flex;
    }
    .settings_tab_list>.react-tabs__tab {
        background: white;
        border-right: none;
        border-radius: 4px;
        border-bottom-left-radius: unset;
        border-bottom-right-radius: unset;
    }
    .settings_tab_list>.react-tabs__tab:last-child {
        border-right: 2px solid #265a9c;
    } 
    .settings_tab_list>.react-tabs__tab--selected {
        background: white;
        color: #000000;
        border: 2px solid #265a9c;
        margin: 0 -2px -1px 0;
        border-bottom: 2px solid white;
    }
    .main_tabs_container>.react-tabs__tab {
        border: none;
    }
`;

const TitlesWrapper = styled.div`
    background: linear-gradient(0deg, #263650 0%, #265a9c 100%);
    width: 100%;
`;

const Title = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 5px;
    color: #ffffff;
`;

const TitleName = styled.span` 
    font-weight: bold;
    margin-left: 5px;
    white-space: normal;
`;

export class LeftPanelContent extends React.Component {
    constructor() {
        super();
        this.state = {
            menuVisible: false,
        }
    }

    render() {
        const { t, chosenProject, chosenFlight }: Props = this.props;
        const { license } = chosenProject;
        return (
            <LeftPanelContentWrapper>
                <TitlesWrapper>
                    <Title>
                        {t('Project')}{': '}<TitleName>{`${chosenProject.name}`}</TitleName>
                    </Title>
                    <Title>
                        {t('Mission')}{': '}<TitleName>{`${chosenFlight ? chosenFlight.projectName : t('Not chosen')}`}</TitleName>
                    </Title>
                </TitlesWrapper>
                <TabsContainer className={'main_tabs_container'}>
                    <FlightManager
                        title={t('Missions')}
                    />
                    {
                        license.faultsEnabled
                            ? <FaultsManager
                                title={t('Faults')}
                            />
                            : null
                    }
                    <CommentsManager
                        title={t('Comments')}
                    />
                    <UploadPanel
                        title={t('Upload')}
                    />
                    <UserWrapper
                        title={t('Settings')}
                    />
                </TabsContainer>
            </LeftPanelContentWrapper>
        );
    }
};

const mapStateToProps = state => ({
    chosenProject: state.auth.get('chosenProject'),
    chosenFlight: state.flightManager.get('chosenFlight'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(LeftPanelContent));


// WEBPACK FOOTER //
// ./src/containers/content/leftPanelContent/LeftPanelContent.jsx